<div class="dashboard-tile" (click)="onClick()">
  <app-icon-thumbnail [icon]="model.icon" [title]="model.label" class="mx-3" [showBadge]="model?.unReadMessages > 0" [unReadMessages]="model?.unReadMessages">
  </app-icon-thumbnail>
  <div class="dashboard-tile-text clickable">
    <h5 class="h5-sub mb-0" style="font-weight: bold;">{{model.label | translate}}</h5>
    <div *ngIf="model.description" >{{model.description | translate }}</div>
  </div>
</div>

